export default "__VITE_ASSET__CVvhjn4E__"